import { Box, SkeletonText, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";

import DeleteIcon from "@/assets/DeleteIcon";
import EditIcon from "@/assets/EditIcon";
import { COLORS } from "@/common/constants";
import Pagination from "../Layouts/Pagination";

const TABLE_COLUMNS = [
    "Key",
    "Name",
    "URL",
    "Is Parent",
    "Order",
    "Is Privileges",
    "Is Reviewer",
    "Action",
];

const TableMenus = ({
    dataList,
    isLoading,
    handleEdit,
    handleDelete,
    currentPageSize,
    handleChangePageSize,
    handleChangePageNumber,
    currentPageNumber,
    totalPageNumber,
    hasNextPage,
}: any) => {
    const renderRows = () => {
        if (isLoading) {
            return (
                <Tr>
                    <Td colSpan={8}>
                        <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                    </Td>
                </Tr>
            );
        }

        if (!dataList || dataList.length === 0) {
            return (
                <Tr>
                    <Td colSpan={8} textAlign="center">Data not found</Td>
                </Tr>
            );
        }

        return dataList.map((item: any) => (
            <Tr key={item.id}>
                <Td>{item.key || '-'}</Td>
                <Td>{item.name || '-'}</Td>
                <Td>{item.url || '-'}</Td>
                <Td>{item.isParent ? 'Yes' : 'No'}</Td>
                <Td>{item.order ?? '-'}</Td>
                <Td>{item.isPrivileges ? 'Yes' : 'No'}</Td>
                <Td>{item.isReviewer ? 'Yes' : 'No'}</Td>
                <Td>
                    <div style={{ display: 'flex', cursor: 'pointer', gap: 8, justifyContent: 'center' }}>
                        <EditIcon onClick={() => handleEdit(item.id)} />
                        <DeleteIcon onClick={() => handleDelete(item.id)} />
                    </div>
                </Td>
            </Tr>
        ));
    };

    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            {TABLE_COLUMNS.map((header) => (
                                <Th
                                    key={header}
                                    color={COLORS.TABLE_HEADER.FOREGROUND}
                                    backgroundColor={COLORS.TABLE_HEADER.BACKGROUND}
                                    textTransform="none"
                                    fontSize={14}
                                    textAlign={header === 'Action' ? 'center' : 'left'}
                                >
                                    {header}
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {renderRows()}
                    </Tbody>
                </Table>
            </Box>
            <Pagination
                currentPageSize={currentPageSize}
                currentPageNumber={currentPageNumber}
                totalPageNumber={totalPageNumber}
                handleChangePageSize={handleChangePageSize}
                handleChangePageNumber={handleChangePageNumber}
                hasNextPage={hasNextPage}
            />
        </TableContainer>
    );
};

export default TableMenus;
